export const escapeRegexChars = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const extractMatchSegments = (str: string, searchWord: string) => {
  const regex = new RegExp(`(.*)(${escapeRegexChars(searchWord).toLowerCase()})(.*)`, 'i');
  return str.match(regex);
};

export const normalizeText = (str: string) => str.toLowerCase();

export const toStringValue = (value: unknown) => String(value);

export const matchesKeyword = (str: string, keyword: string) =>
  normalizeText(str).includes(keyword);

export const toKebabCase = (str: string) => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[_\s]+/g, '-')
    .toLowerCase();
};

export const normalizeInputSpacesOnChange = (str: string) => {
  return str.replace(/\s+/g, ' ').trimStart();
};

export const removeAllSpaces = (str: string) => {
  return str.replace(/\s+/g, '').trim();
};

export const normalizeInputSpacesOnBlur = (str: string) => {
  return str.trimEnd();
};
